import React from "react";
import SH from "./SH";
import styled from "styled-components";
import Pencil from "react-icons/lib/fa/pencil";
import { Code } from "rebass";
import Block from "./Block";

const Container = styled.div`
    background-color: #fcf6e5;
    border: 1px solid #d8ceb1;
    border-radius: 2px;
    padding: 0.5em;
    margin-top: 0.5em;
`;

const Handler = styled.div`
    color: #b7a980;
    ${props =>
        props.border &&
        `border-bottom: 1px solid #D8CEB1;
        padding-bottom: 0.5em;`} cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
`;

class Exercise extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
    }
    open() {
        this.setState({ open: true });
    }
    close() {
        this.setState({ open: false });
    }
    render() {
        const { language, language2, code, code2, path, path2, children } = this.props;
        return <Block tint={221} icon={Pencil} header="Exercise">
                {children}
                {code && <Container>
                        {this.state.open ? <div>
                                <Handler border={true} onClick={this.close.bind(this)}>
                                    Hide the solution
                                </Handler>
                                <div>
                                    <div>
                                        <Code>{path}</Code>
                                    </div>
                                    <SH language={language} code={code} />
                                </div>
                                {code2 && <div>
                                        <div>
                                            <Code>{path2}</Code>
                                        </div>
                                        <SH language={language2} code={code2} />
                                    </div>}
                            </div> : <Handler
                                onClick={this.open.bind(this)}
                            >
                                Reveal the solution
                            </Handler>}
                    </Container>}
            </Block>;
    }
}

export default Exercise;



// WEBPACK FOOTER //
// ./src/components/Exercise.js